import { createFileRoute, Link } from '@tanstack/react-router';
import { useState } from 'react';
import { authService } from '@/features/auth/services/auth.service';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useBrandingStore } from '@/store/branding.store';
import { CheckCircle2, ArrowLeft } from 'lucide-react';

export const Route = createFileRoute('/forgot-password')({
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  const branding = useBrandingStore((s) => s.branding);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await authService.forgotPassword(email.trim());
    } catch {
      // intencional: resposta silenciosa para não vazar existência de email
    } finally {
      setLoading(false);
      setSent(true);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-page-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="mb-3 flex justify-center">
            <img
              src={branding?.logoUrl ?? '/assets/favicon-128x128.png'}
              alt={`Logo ${branding?.appName ?? 'Asseto'}`}
              className="h-14 w-14 rounded-xl object-contain"
            />
          </div>
          <CardTitle className="text-center">Recuperação de senha</CardTitle>
          <CardDescription className="text-center">
            {sent
              ? 'Verifique sua caixa de entrada'
              : 'Informe seu email para receber o link de redefinição'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="space-y-4 text-center">
              <CheckCircle2 className="h-12 w-12 text-green-500 mx-auto" />
              <p className="text-sm text-muted-foreground">
                Se o email <strong>{email}</strong> estiver cadastrado, você receberá um link de
                redefinição de senha em breve. Verifique também a caixa de spam.
              </p>
              <Link
                to="/login"
                className="flex items-center justify-center gap-1.5 text-sm text-primary hover:underline"
              >
                <ArrowLeft className="h-4 w-4" />
                Voltar ao login
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="seu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <Button type="submit" className="w-full" disabled={loading || !email.trim()}>
                {loading ? 'Enviando...' : 'Enviar link de recuperação'}
              </Button>

              <Link
                to="/login"
                className="flex items-center justify-center gap-1.5 text-sm text-muted-foreground hover:text-primary hover:underline"
              >
                <ArrowLeft className="h-4 w-4" />
                Voltar ao login
              </Link>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
